module.exports = __webpack_public_path__ + "static/media/wordpress.7292ff4d.gif";